import { render } from "./BuzzPostInput.vue?vue&type=template&id=6f4c1ab6&scoped=true&ts=true"
import script from "./BuzzPostInput.vue?vue&type=script&lang=ts"
export * from "./BuzzPostInput.vue?vue&type=script&lang=ts"

import "./buzz-post-input.scss?vue&type=style&index=0&id=6f4c1ab6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4c1ab6"]])

export default __exports__